module.exports = __webpack_public_path__ + "static/media/icon_9.50a72977.svg";